export const ERROR_REPONSE_DEFAULT = [
  { type: 'error', message: 'Erro no servidor. Entre em contato com o suporte' },
];
